import { type FC } from 'react';
import QuestionsList from './QuestionsList';

interface TechnicalAssessmentListProps {
  offerId: number;
}

const TechnicalAssessmentList: FC<TechnicalAssessmentListProps> = ({
  offerId,
}) => {

  return <QuestionsList offerId={offerId} />;
};

export default TechnicalAssessmentList;